import React from "react";
import ArrowNe from "../ArrowNe.js";
import "./product.scss";

const Product = () => {
  return (
    <section id="product" className="mz-product">
      <div className="mz-product__grid" aria-hidden="true" />
      <div className="mz-wrap mz-product__inner">
        <img
          className="mz-product__glow"
          src="/assets/figma/product-glow.svg"
          alt=""
          aria-hidden="true"
        />
        <div className="mz-product__copy">
          <div className="mz-chip mz-chip--dark">OUR PRODUCT</div>
          <div className="mz-product__heading">
            <h2 className="mz-product__title">We build Joni.</h2>
            <p className="mz-product__body">
              Joni is the Operating System for AI. Every user gets their own always-on AI computer, where agents plan, build, and ship real work end to end. Designed, engineered, and operated by the Mezada team.
            </p>
          </div>
          <a
            className="mz-product__cta"
            href="https://joni.ai"
            target="_blank"
            rel="noreferrer"
          >
            Meet Joni
            <ArrowNe />
          </a>
        </div>
        <div className="mz-product__phone">
          <img
            src="/assets/figma/iphone.png?v=3"
            srcSet="/assets/figma/iphone.png?v=3 2x"
            width="349"
            height="479"
            alt="Joni on iPhone"
          />
        </div>
      </div>
    </section>
  );
};

export default Product;
